import { State } from '@app/main-store/feature-flags.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RequestState } from '@app/_shared/interfaces';

const getFeatureFlagsState = createFeatureSelector<State>('featureFlags');

export const companyFeatureFlags = createSelector(getFeatureFlagsState, (state) => state.companyFeatureFlags);

const requestStates = createSelector(getFeatureFlagsState, (state) => state.requestStates);

export const loadingFeatureFlags = createSelector(
  requestStates,
  (requestStates) => requestStates.companyFeatureFlags === RequestState.LOADING,
);
